import { GtmhubController } from "@gtmhub/core";
import { BetaFeaturesService, FeatureToggleV2Service } from "@gtmhub/featureToggle";
import { IScope, IQService, ITimeoutService, IPromise, IComponentOptions, IAugmentedJQuery } from "angular";
import { StateService, TransitionService } from "@uirouter/angularjs";
import { IModalService } from "angular-ui-bootstrap";
import { AccountType, IAccount, IRestLayerRequest } from "@gtmhub/core";
import { UserProfileService } from "@gtmhub/users/userProfile/profileService";
import { IProfile } from "@webapp/users/models/users.models";
import { INotificationIndicators } from "@gtmhub/notifications/models/notifications";
import { IReport } from "@gtmhub/reporting/models";
import { ILeftNavItems, ISubscriptionConverted } from "@gtmhub/login/models";
import { IList, ListChangedEvent, ListService } from "@gtmhub/lists";
import { IHubWorkflowActions, IHubWorkflowItemsCollection } from "@gtmhub/hub/models/hub";
import { ProgressColoring, IBrandingImage, IColoringSetup } from "@gtmhub/configuration";
import { ILoginRootScopeService } from "@gtmhub/login/controllers/create-account-ctrl";
import { ITraceRootScopeService, Zone } from "@gtmhub/core/tracing";
import { AccountService } from "@gtmhub/accounts/accountsService";
import { AccountResolverService } from "@gtmhub/state/accountResolverService";
import { AuthenticationResolverService, getAuth0UserId } from "@gtmhub/auth";
import { CurrentUserService, IUser, UserService, getCurrentUserId } from "@gtmhub/users";
import { NotificationsService } from "@gtmhub/notifications/services/notificationsService";
import { IUIError, UIErrorHandlingService } from "@gtmhub/error-handling";
import { localize } from "@gtmhub/localization";
import { InsightboardService } from "@gtmhub/insightboards/services/dashboardService";
import { AnalyticsService } from "@gtmhub/core/analytics";
import { CurrentEmployeeActions, ICurrentEmployeeStoreState, IEmployee } from "@gtmhub/employees";
import { HomeService, IHomeMetric } from "@gtmhub/home/services/home";
import { TaskService, ITask } from "@gtmhub/tasks";
import { MetricService, IMetric } from "@gtmhub/okrs/metrics";
import { PageTitleService } from "@gtmhub/shared/services/pageTitleService";
import { INgRedux } from "@gtmhub/state-management";
import { PlanningSessionsActions, ISessionsStoreState, filterActiveSessions, IPlanningSession, PlanningSessionService } from "@gtmhub/sessions";
import { INotificationsCountData } from "@gtmhub/sockets";
import { ICollection } from "@gtmhub/models";
import { byTextField } from "@gtmhub/util/sorting";
import { NavigationEvents } from "../events";
import { IExtendedRootScopeService } from "@gtmhub/shared/ng-extensions";
import { getMessagesCount, filterInActiveSessions } from "./utils";
import { MultiAccountService } from "../../multi-account/services/multi-account-service";
import { IUserMultiAccount, UserMultiAccountInvitationTypes } from "../../multi-account/models";
import { NotificationsInboxService } from "@gtmhub/notifications/controllers/notifications-inbox";
import { toggleClass } from "@gtmhub/shared/dom";
import { IPlan, isAccountWithBasicEdition, PricingEditionService } from "@gtmhub/edition-plan-change";
import { FeatureFlag } from "@gtmhub/featureToggle/models";
import { setTopNavBarProps } from "@gtmhub/shared/components/ui/top-navigation-bar/utils";
import { setNavWidth } from "@webapp/navigation/utils/navigation.util";
import { userHasOnlyResctrictedRole } from "@gtmhub/lists/controllers/helpers";
import { GoalsChangedEventArgs, OkrEvents } from "@gtmhub/okrs";

interface INavigationRedux {
  allSessions: IPlanningSession[];
  reduxStatesInitialized: boolean;
  reduxStateError: IUIError;
  employee: IEmployee;
}

const bindStateToCtrl = (state: ISessionsStoreState & ICurrentEmployeeStoreState): INavigationRedux => {
  const { items: allSessions, isFetched: sessionsFetched, error: sessionsError } = state.sessions;
  const { info: currentEmployee, isFetched: currentEmployeeFetched, error: currentEmployeeError } = state.currentEmployee;

  return {
    allSessions,
    reduxStatesInitialized: sessionsFetched && currentEmployeeFetched,
    reduxStateError: sessionsError || currentEmployeeError,
    employee: currentEmployee,
  };
};

const editionPlanChangeState = "gtmhub.editionPlanChange";
const workflowActions = "workflowActions";
const workflowItems = "workflowItems";
const userWorkflowItemsFields = "hubWorkflowItems{goalsToReview{id,name,currentUserApproved},itemsToReview,actionsNeededToReview,actionsNeededOwned}";

const topPositionsLeftItemsBasedOnAccountType: {
  readonly client: number;
  readonly internal: number;
  readonly trial: number;
  readonly demo: number;
} = {
  client: 54,
  internal: 87,
  trial: 124,
  demo: 72,
};
const okrsForApprovalHeight = 28;

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface NavigationComponentCtrl extends INavigationRedux {}
export class NavigationComponentCtrl extends GtmhubController {
  sessionsTotalCount: number;
  sessions: IPlanningSession[];

  brandingImageUrl?: string;
  account: IAccount;
  progress: number;
  profile: IProfile;
  newMessagesCount: number;
  unreadNotificationsCount: string;
  indicators: INotificationIndicators;
  secondsLeft: number;
  version: string;
  currentState: string;
  reports: IReport[];
  leftNavItems: ILeftNavItems;
  isMacOperationSystem: boolean;
  isAccountEditionBasic: boolean;
  hasAccountEditionPermission: boolean;
  isAccountTrial: boolean;
  isAccountClient: boolean;
  isDemoAccount: boolean;
  lists: IList[];
  userMultiAccounts: IUserMultiAccount[];

  workflowActions: IHubWorkflowActions;
  workflowItems: IHubWorkflowItemsCollection;
  workflowCurrentUserActions: {
    actionsNeeded: number;
    actionsNeededOwned: number;
    actionsNeededToReview: number;
  };
  showOkrsForApproval: boolean;
  isDropdownOpen: boolean;

  notUpdatedMetricsIdsInCurrentCadence: string[];

  // feature toggle
  isMultiAccountEnabled: boolean;

  // for ux
  topPositionLeftItems: number;
  todoActionsCount: number;
  isSettingsHighlighted: boolean;
  private isAccountConverted = false;
  private navEvents: NavigationEvents;
  private okrEvents: OkrEvents;
  private plans: IPlan[];

  hideReadonlySessions: boolean;
  currentUser: IUser;
  newExperience: {
    optionEnabled?: boolean;
    experienceEnabled?: boolean;
  } = {};

  public static $inject = [
    "$rootScope",
    "$transitions",
    "$scope",
    "$ngRedux",
    "PlanningSessionsActions",
    "CurrentEmployeeActions",
    "$state",
    "$element",
    "AccountService",
    "AccountResolverService",
    "AuthenticationResolverService",
    "CurrentUserService",
    "PlanningSessionService",
    "$uibModal",
    "$q",
    "NotificationsService",
    "UIErrorHandlingService",
    "UserProfileService",
    "$timeout",
    "InsightboardService",
    "AnalyticsService",
    "ListService",
    "HomeService",
    "TaskService",
    "MetricService",
    "PageTitleService",
    "ProgressColoring",
    "MultiAccountService",
    "NotificationsInboxService",
    "UserService",
    "PricingEditionService",
    "BetaFeaturesService",
    "FeatureToggleV2Service",
  ];

  constructor(
    private $rootScope: ILoginRootScopeService & ITraceRootScopeService,
    private $transitions: TransitionService,
    private $scope: IScope & IExtendedRootScopeService & { currentUserRestricted: boolean; currentUserHasLists: boolean },
    $ngRedux: INgRedux,
    planningSessionActions: PlanningSessionsActions,
    currentEmployeeActions: CurrentEmployeeActions,
    private $state: StateService,
    private $element: IAugmentedJQuery,
    private accountService: AccountService,
    private accountResolverService: AccountResolverService,
    private authenticationResolverService: AuthenticationResolverService,
    private currentUserService: CurrentUserService,
    private planningSessionService: PlanningSessionService,
    private $uibModal: IModalService,
    private $q: IQService,
    private notificationsService: NotificationsService,
    private uiErrorHandlingService: UIErrorHandlingService,
    private userProfileService: UserProfileService,
    private $timeout: ITimeoutService,
    private insightboardService: InsightboardService,
    private analyticsService: AnalyticsService,
    private listService: ListService,
    private homeService: HomeService,
    private taskService: TaskService,
    private metricService: MetricService,
    private pageTitleService: PageTitleService,
    private progressColoring: ProgressColoring,
    private multiAccountService: MultiAccountService,
    private notificationsInboxService: NotificationsInboxService,
    private userService: UserService,
    private pricingEditionService: PricingEditionService,
    private betaFeaturesService: BetaFeaturesService,
    private featureToggleV2Service: FeatureToggleV2Service
  ) {
    super();

    this.okrEvents = new OkrEvents(this.$scope);
    this.okrEvents.onGoalsChanged((args) => this.onGoalsUpdated(args));

    const unloadListener = () => this.currentUserService.setMarketplaceRedirectCookie();
    window.addEventListener("beforeunload", unloadListener);
    setNavWidth({ expanded: "220px", collapsed: "60px" });
    setTopNavBarProps({ height: "40px", borderColor: "rgba(0, 85, 204, 0.1)" });

    this.onDestroy($ngRedux.connect(bindStateToCtrl)(this));
    this.onDestroy(() => window.removeEventListener("beforeunload", unloadListener));

    $ngRedux.dispatch(planningSessionActions.getSessionsIfMissing());
    $ngRedux.dispatch(currentEmployeeActions.fetchCurrentEmployeeIfMissing());

    this.currentState = this.$state.current.name;

    if (navigator && navigator.platform) {
      this.isMacOperationSystem = navigator.platform.includes("Mac");
    }

    this.indicators = {};
    this.account = this.accountResolverService.getAccountData();
    this.profile = this.userProfileService.getProfile();

    const subscription = this.account.subscriptions.find((license) => license.type === "regular");
    if (subscription !== undefined && subscription.isConverted !== undefined) {
      this.isAccountConverted = subscription.isConverted;
    }

    this.isAccountTrial = this.account.type === AccountType.TrialAccount && !this.isAccountConverted;
    this.isAccountClient = this.account.type === AccountType.ClientAccount || this.isAccountConverted;
    this.isDemoAccount = this.account.type === AccountType.DemoAccount;
    this.newExperience.optionEnabled = this.accountService.getAccountSetting<Record<"enabled", boolean>>("newExperience")?.enabled || false;

    const onWindowResize = () => {
      this.closeMenuUnder1280();
      this.openMenuOver1280();
    };
    window.addEventListener("resize", onWindowResize);
    this.$scope.$on("$destroy", () => window.removeEventListener("resize", onWindowResize));

    this.brandingImageUrl = this.accountService.getAccountSetting("branding");
    this.$scope.$on("brandingImageChanged", (evt, image: IBrandingImage) => this.onBrandingImageChanged(image));

    this.$scope.$on("goalsChanged", () => this.onGoalsChanged());
    this.$scope.$on("notificationsCount", (evt, data: INotificationsCountData) => this.updateNotificationsCount(data));
    this.$scope.$on("newMessagesCount", (evt, count: number) => this.updateNewMessagesCount(count));
    this.$scope.$on("subscriptionConverted", (evt, subscriptionConverted: ISubscriptionConverted) => this.subscriptionConverted(subscriptionConverted));
    this.$scope.$on("newExperienceSwitch", (evt, enabled: boolean) => (this.newExperience.optionEnabled = enabled));

    this.$scope.$on(
      "$destroy",
      this.$transitions.onSuccess({}, (trans) => {
        const from = trans.from();
        this.isSettingsHighlighted = from.name === "gtmhub.home._invitation.invite" && trans.router.globals.current.name === "gtmhub.usersList";
        this.currentState = this.$state.current.name;
      })
    );

    this.$rootScope.$on("untoggleSessions", () => this.toggleLeftNavItems("okrs"));

    const onListChanged = (evt, list: IList, listChangedEvent: ListChangedEvent) => this.onListChanged(list, listChangedEvent);
    this.$rootScope.$on("listCreated", onListChanged);
    this.$rootScope.$on("listUpdated", onListChanged);
    this.$rootScope.$on("listDeleted", onListChanged);

    // subscribing for profile changes as in update profile form.
    this.subscribeForProfileUpdated();
    this.accountService.setConfidenceScale(this.accountService.getAccountSetting("confidenceScale"));
    this.accountService.checkConfidenceSettings();
    this.setColoringScale();
    this.calculateTopPositionLeftItems();
    this.checkExpiration();
    this.setLeftNavItems();
    this.closeMenuUnder1280();
    this.openMenuOver1280();
    this.adjustMarginsOnIntercomBanners();

    this.$rootScope.traceAction("menu_init", () => this.init(), Zone.root);

    this.navEvents = new NavigationEvents($scope);
  }

  private init(): IPromise<unknown> {
    return this.$scope
      .watchUntilAndRejectOnError(
        () => this.reduxStatesInitialized,
        () => this.reduxStateError
      )
      .then(
        () => {
          const initPromises: IPromise<unknown>[] = [];

          initPromises.push(this.getReports());
          initPromises.push(this.getLeftNavLists());
          initPromises.push(this.getNewMessagesCount());
          initPromises.push(this.getUserActionsCount());
          initPromises.push(this.getUserCurrentWorkflowItems());
          initPromises.push(this.getUserMultiAccounts());
          initPromises.push(this.getCurrentUser());
          initPromises.push(this.getAllowedTransitions());
          initPromises.push(this.isNewExperienceEnabled());
          initPromises.push(this.isHideReadonlyFeatureEnabled());
          initPromises.push(this.isLockMultiAccountEnabled());

          return this.$q.all(initPromises).then(() => {
            this.processSessions();
            this.getHomeTodoItems();

            this.$scope.$watch("$ctrl.allSessions", (value: IPlanningSession[]) => {
              this.sessions = filterInActiveSessions(value, this.currentUser, this.hideReadonlySessions);
            });
          });
        },
        (error) => this.uiErrorHandlingService.handleModal(error)
      );
  }

  private isNewExperienceEnabled(): IPromise<void> {
    return this.featureToggleV2Service.isFeatureAvailable(FeatureFlag.NewExperienceToggle).then((enabled) => {
      this.newExperience.experienceEnabled = enabled;
    });
  }

  private isHideReadonlyFeatureEnabled(): IPromise<void> {
    return this.featureToggleV2Service.isFeatureAvailable(FeatureFlag.HideReadonlySessions).then((enabled) => {
      this.hideReadonlySessions = enabled;
    });
  }

  private isLockMultiAccountEnabled(): IPromise<void> {
    return this.featureToggleV2Service.isFeatureAvailable(FeatureFlag.LockMultiAccount).then((isLockMultiAccountEnabled) => {
      this.isMultiAccountEnabled = !isLockMultiAccountEnabled;
    });
  }

  private getAllowedTransitions(): IPromise<void> {
    return this.pricingEditionService.getAllowedTransitions(this.account.type).then((plans) => {
      this.plans = plans;
      this.setAccountEditionBasic();
    });
  }

  private getReports(): IPromise<void> {
    return this.insightboardService.getReports().then((reports: IReport[]) => {
      reports.forEach((report) => {
        report.name = this.translateReportName(report.name);
      });

      this.reports = reports;
      this.homeService.cachedReports = reports;
    });
  }

  private getNewMessagesCount(): IPromise<void> {
    // no dedicated endpoint from backend for getting count of new messages => use getNotifications with skip zero, take one, and seen false
    return this.notificationsService.getNotifications(null, null, null, false, 0, 1).then((notifications) => {
      const count = notifications.totalCount;
      this.newMessagesCount = count;
      this.unreadNotificationsCount = getMessagesCount(count);
    });
  }

  onMouseLeave(): void {
    if (this.$rootScope.hideMenu && this.isDropdownOpen) {
      this.isDropdownOpen = false;
    }
  }

  onDropdownToggle(isOpen: boolean): void {
    this.isDropdownOpen = isOpen;
  }

  upgradePlan(): void {
    this.$state.go(editionPlanChangeState);
  }

  logout(): void {
    this.authenticationResolverService.logout({ ssoLogoutIfEnabled: true });
  }

  openNotifications(): void {
    let windowClass = "sidebar-modal large right inbox-modal";
    if (this.$rootScope.hideMenu) {
      windowClass = "sidebar-modal large right inbox-modal hide-nav";
    }
    this.notificationsInboxService.open(windowClass, this.indicators, this.newMessagesCount);
  }

  openAccountPickerModal(): void {
    this.$uibModal.open({
      windowClass: "account-picker-modal",
      component: "accountPicker",
      resolve: {
        accounts: () => this.userMultiAccounts,
      },
    });
  }

  isAllowedToSwitchAccount(): boolean {
    return (
      this.isMultiAccountEnabled &&
      this.userMultiAccounts &&
      !!this.userMultiAccounts.find((acc) => acc.invitation && acc.invitation.status === UserMultiAccountInvitationTypes.approved)
    );
  }

  toggleLeftNavItems(item: string, navToggleIsClicked?: boolean): void {
    this.leftNavItems[item] = !this.leftNavItems[item];

    if (item === "leftNavIsClosed") {
      this.$rootScope.hideMenu = !this.$rootScope.hideMenu;
      // if toggle arrow is clicked, preferred navigation state is saved
      if (navToggleIsClicked) {
        this.leftNavItems.isNavPreferredOpened = !this.leftNavItems.isNavPreferredOpened;
      }
      // run with timeout to give Angular.js a chance to re-render the UI, so other component
      // can calculate the correct size of the area with/without the navigation
      this.$timeout(() => this.navEvents.broadcastNavigationToggled({ hideMenu: this.$rootScope.hideMenu }));

      this.$timeout(() => {
        toggleClass(this.$element[0], "hiddenNavigation");

        const modalEl = document.querySelector<HTMLElement>(".checklist-modal");
        if (modalEl) {
          toggleClass(modalEl, "hiddenNavigation");
        }
      }, 600);
    }
    this.$rootScope.traceAction("toggle_left_nav_items", () => {
      this.currentUserService.setUserSetting({ leftNavItems: this.leftNavItems });
    });
  }

  trackDemoSession(demoSession: boolean): void {
    if (demoSession) {
      this.analyticsService.track("Demo Session Opened From Sidenav");
    }
  }

  private closeMenuUnder1280(): void {
    if (window.innerWidth <= 1280 && !this.$rootScope.hideMenu) {
      this.toggleLeftNavItems("leftNavIsClosed");
    }
  }

  private openMenuOver1280(): void {
    if (window.innerWidth >= 1280 && this.$rootScope.hideMenu && this.leftNavItems.isNavPreferredOpened) {
      this.toggleLeftNavItems("leftNavIsClosed");
    }
  }

  private adjustMarginsOnIntercomBanners(): void {
    /*
     * MutationObserver allows us to watch for changes being made to the DOM tree.
     * In this case, I use it to watch changes only for styles attribute on the body.
     * It can be used for an HTML element.
     *
     * More information -> https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver
     */

    const mutationObserver = new MutationObserver(() => {
      const bodyMargin = document.body.style.margin;
      const bodyMarginTop = document.body.style.marginTop;

      if (bodyMargin || bodyMarginTop) {
        // disconnect observer after the first time when removing margin from the body
        document.body.style.margin = "";
        document.body.style.marginTop = "";
        mutationObserver.disconnect();
      }
    });

    const mutationObserverOptions: MutationObserverInit = {
      attributes: true,
      attributeFilter: ["style"],
    };

    const target = document.body;
    mutationObserver.observe(target, mutationObserverOptions);
  }

  private setAccountEditionBasic() {
    this.hasAccountEditionPermission = !!this.plans.length;
    if (!this.hasAccountEditionPermission) {
      return;
    }

    this.isAccountEditionBasic = isAccountWithBasicEdition(this.plans);
  }

  private updateNotificationsCount(data: INotificationsCountData) {
    this.newMessagesCount = data.totalCount;
    this.unreadNotificationsCount = getMessagesCount(data.totalCount);
  }

  private updateNewMessagesCount(count: number) {
    this.newMessagesCount = count;
    this.unreadNotificationsCount = getMessagesCount(count);
  }

  private getHomeTodoItems() {
    this.$scope.$on("approvedGoal", () => {
      this.todoActionsCount -= 1;
      this.pageTitleService.setNotificationsCount(this.todoActionsCount);
    });

    this.$scope.$on("todoTaskAdded", () => {
      this.todoActionsCount += 1;
      this.pageTitleService.setNotificationsCount(this.todoActionsCount);
    });

    this.$scope.$on("todoTaskDeleted", () => {
      this.todoActionsCount -= 1;
      this.pageTitleService.setNotificationsCount(this.todoActionsCount);
    });

    // todo: remove activeSessionIds when there's proper fix for OKRs from archived sessions
    const employeeIdAndTeamIds = this.homeService.getEmployeeTeamIds(this.employee);
    const activeSessions = filterActiveSessions(this.allSessions);
    const activeSessionIds = activeSessions.map((s) => s.id);

    const mongoTaskFilter: IRestLayerRequest = {
      filter: {
        $and: [
          { ownerId: this.employee.id },
          { status: { $in: ["inprogress", "todo"] } },
          {
            $or: [{ sessionId: { $exists: false } }, { sessionId: { $in: activeSessionIds } }],
          },
          { $or: [{ archived: { $exists: false } }, { archived: false }] },
        ],
      },
      fields: "dueDate,name,parentId",
    };

    const mongoMetricsFilter: IRestLayerRequest = {
      filter: {
        $and: [{ ownerIds: { $in: employeeIdAndTeamIds } }, { sessionId: { $in: activeSessionIds } }],
      },
      // *****lastCheckinDate must go with latestSnapshotAt otherwise the endpoint doesn't return the field*****
      fields: "id,goalId,name,sessionId,ownerIds,dueDate,attainment,manualType,lastCheckInDate,latestSnapshotAt",
    };

    return this.$q
      .all({
        metrics: this.metricService.getMetricsV2(mongoMetricsFilter),
        tasks: this.taskService.getTasksV2(mongoTaskFilter),
      })
      .then(
        (map: { metrics: ICollection<IMetric>; tasks: ICollection<ITask> }) => {
          const activeSessionsMap = this.homeService.getActiveSessionsMap(activeSessions);
          const metricsNotUpdated = this.homeService.getNotUpdatedMetricsInCurrentCadence(map.metrics.items as IHomeMetric[], activeSessionsMap, this.employee);
          const goalsNotApproved = this.homeService.getGoalsToApprove(this.workflowItems.hubWorkflowItems, this.allSessions);

          this.todoActionsCount = (goalsNotApproved.length || 0) + (metricsNotUpdated.length || 0) + (map.tasks.totalCount || 0);
          this.pageTitleService.setNotificationsCount(this.todoActionsCount);
          this.notUpdatedMetricsIdsInCurrentCadence = metricsNotUpdated.map((metric) => metric.id);
        },
        (error) => this.uiErrorHandlingService.handleModal(error)
      );
  }

  private getUserActionsCount(): IPromise<void> {
    return this.planningSessionService.getCurrentUserActionsCount().then((workflowActions) => {
      this.workflowActions = workflowActions;
      this.showOkrsForApproval = this.workflowActions.enabled && !!this.workflowActions.totalActionsNeeded;

      if (this.showOkrsForApproval) {
        this.calculateTopPositionLeftItems(okrsForApprovalHeight);
      }
    });
  }

  private getUserCurrentWorkflowItems(): IPromise<void> {
    return this.planningSessionService.getCurrentUserWorkflowItems(userWorkflowItemsFields).then((workflowItems) => {
      this.workflowItems = workflowItems;
      this.processWorkflowCurrentUserActions();
    });
  }

  private getUserMultiAccounts(): IPromise<void> {
    return this.multiAccountService.getUserMultiAccounts(getAuth0UserId()).then((multiAccounts) => {
      this.userMultiAccounts = multiAccounts;
    });
  }

  private getCurrentUser(): IPromise<void> {
    return this.userService.getUser(getCurrentUserId()).then((user) => {
      this.currentUser = user;
      const roleNames = user?.roles?.map((role) => role.name) || [];
      this.$scope.currentUserRestricted = userHasOnlyResctrictedRole(roleNames);
    });
  }

  private processSessions(): void {
    this.$rootScope.demoSession = this.allSessions.find((session) => session.demo === true);
    this.sessionsTotalCount = this.allSessions.length;
  }

  private translateReportName(name: string) {
    const key = name.toLowerCase().replace(" ", "_");
    const translatedName = localize(key);
    return translatedName || name;
  }

  private checkExpiration = (): void => {
    this.secondsLeft = this.accountResolverService.checkExpirationOfTrialAccount().secondsLeft;
  };

  private setLeftNavItems(): void {
    if (this.currentUserService.getUserSetting("leftNavItems")) {
      this.leftNavItems = this.currentUserService.getUserSetting("leftNavItems");
    } else {
      this.leftNavItems = {
        leftNavIsClosed: false,
        isNavPreferredOpened: true,
        hub: true,
        okrs: false,
        tasks: false,
        reports: false,
        insights: false,
        people: false,
        lists: false,
        experiments: false,
      };
    }

    this.$rootScope.hideMenu = this.leftNavItems.leftNavIsClosed;

    if (this.$rootScope.hideMenu) {
      this.$element[0].classList.add("hiddenNavigation");

      const modalEl = document.querySelector(".checklist-modal");
      if (modalEl) {
        modalEl.classList.add("hiddenNavigation");
      }
    }
  }

  private subscriptionConverted(subscriptionConverted: ISubscriptionConverted): void {
    if (this.account.id === subscriptionConverted.accountId) {
      const subscriptionTypeRegular = subscriptionConverted.subscriptions.find((license) => license.type === "regular");
      if (subscriptionTypeRegular !== undefined) {
        this.isAccountTrial = !subscriptionTypeRegular.isConverted;
        this.isAccountClient = subscriptionTypeRegular.isConverted;
      }

      this.plans = this.plans.map((plan) => ({ ...plan, isSelected: plan.id === subscriptionConverted.accountEdition.planId }));
      this.setAccountEditionBasic();

      this.showOkrsForApproval = this.workflowActions.enabled && !!this.workflowActions.totalActionsNeeded;

      if (this.showOkrsForApproval) {
        this.calculateTopPositionLeftItems(okrsForApprovalHeight);
      } else {
        this.calculateTopPositionLeftItems();
      }

      this.$scope.$apply();
    }
  }

  private getLeftNavLists(): IPromise<unknown> {
    const listIds: string[] = this.currentUserService.getUserSetting("listIds");

    return this.listService.getLists({ sort: "title", fields: "title,color" }).then(
      (lists) => {
        this.$scope.currentUserHasLists = lists?.items?.length > 0;

        if (listIds?.length) {
          this.lists = lists?.items?.filter((item) => listIds.indexOf(item.id) !== -1) || [];
        }
      },
      (error) => this.uiErrorHandlingService.handleModal(error)
    );
  }

  private onListChanged(list: IList, listChangedEvent: ListChangedEvent): void {
    if (!this.lists) {
      this.lists = [];
    }

    const listToBeUpdated = this.lists.find((newItem) => newItem.id === list.id);

    switch (listChangedEvent) {
      case ListChangedEvent.Added:
        this.lists = [...this.lists, list].sort(byTextField("title"));
        return;
      case ListChangedEvent.Deleted:
        this.lists = this.lists.filter((l) => l.id !== list.id);
        return;
      case ListChangedEvent.Modified:
        this.lists[this.lists.indexOf(listToBeUpdated)] = list;
        return;
    }
  }

  private onBrandingImageChanged(image: IBrandingImage): void {
    this.brandingImageUrl = image ? image.url : null;
  }

  private onGoalsChanged(): void {
    this.$q
      .all({
        [workflowActions]: this.planningSessionService.getCurrentUserActionsCount(),
        [workflowItems]: this.planningSessionService.getCurrentUserWorkflowItems(userWorkflowItemsFields),
      })
      .then(
        (map) => {
          this.workflowActions = map[workflowActions] as IHubWorkflowActions;
          this.workflowItems = map[workflowItems] as IHubWorkflowItemsCollection;
          this.processWorkflowCurrentUserActions();

          this.showOkrsForApproval = this.workflowActions.enabled && !!this.workflowActions.totalActionsNeeded;

          if (this.showOkrsForApproval) {
            this.calculateTopPositionLeftItems(okrsForApprovalHeight);
          } else {
            this.calculateTopPositionLeftItems();
          }
        },
        (error) => this.uiErrorHandlingService.handleModal(error)
      );
  }

  private onGoalsUpdated = (args: GoalsChangedEventArgs): void => {
    if (args.reason === "metricUpdated") {
      this.onMetricUpdated(args.detail.metric);
      return;
    }
    if (args.reason === "goalChanged") {
      this.onGoalsChanged();
    }
  };

  private onMetricUpdated(metric: IMetric): void {
    if (this.notUpdatedMetricsIdsInCurrentCadence.includes(metric.id)) {
      this.todoActionsCount -= 1;
      this.pageTitleService.setNotificationsCount(this.todoActionsCount);
      this.notUpdatedMetricsIdsInCurrentCadence = this.notUpdatedMetricsIdsInCurrentCadence.filter((id) => id !== metric.id);
    }
  }

  private processWorkflowCurrentUserActions(): void {
    let actionsNeededToReview = 0;
    let actionsNeededOwned = 0;

    Object.values(this.workflowItems.hubWorkflowItems).forEach((workflowItem) => {
      actionsNeededToReview += workflowItem.actionsNeededToReview;
      actionsNeededOwned += workflowItem.actionsNeededOwned;
    });

    const actionsNeeded = actionsNeededToReview ? actionsNeededToReview : actionsNeededOwned;

    this.workflowCurrentUserActions = {
      actionsNeeded,
      actionsNeededOwned,
      actionsNeededToReview,
    };
  }

  private calculateTopPositionLeftItems(additionalPXs = 0): void {
    // this method is to calc top position of .left-items div
    if (this.isAccountTrial) {
      this.topPositionLeftItems = topPositionsLeftItemsBasedOnAccountType.trial + additionalPXs;
    } else if (this.isAccountClient) {
      this.topPositionLeftItems = topPositionsLeftItemsBasedOnAccountType.client + additionalPXs;
    } else if (this.isDemoAccount) {
      this.topPositionLeftItems = topPositionsLeftItemsBasedOnAccountType.demo + additionalPXs;
    } else {
      this.topPositionLeftItems = topPositionsLeftItemsBasedOnAccountType.internal + additionalPXs;
    }
  }

  private subscribeForProfileUpdated() {
    this.$rootScope.$on("userProfileUpdated", (evt, arg: IProfile) => {
      this.profile = arg;
    });
  }

  private setColoringScale(): void {
    const accountColoring = this.accountService.getAccountSetting<IColoringSetup>("coloring");
    this.progressColoring.setColoring(accountColoring);
  }

  goToHomeScreen(): void {
    this.$state.go("gtmhub.home");
  }

  toggleNewExperience(): void {
    this.newExperience.experienceEnabled = !this.newExperience.experienceEnabled;
    this.betaFeaturesService.optForBetaFeature("new-experience-toggle", this.newExperience.experienceEnabled).then(() => {
      document.location.reload();
    });
  }
}

export const NavigationComponent: IComponentOptions = {
  templateUrl: require("./navigation.jade"),
  controller: NavigationComponentCtrl,
};
